import { StreamData } from 'types/streamData'
import { getRelativeTimeString } from 'utils/dateUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const timestampResolver: FieldResolver = (metadata: Metadata) =>
  ({
    timestamp: getRelativeTimeString(metadata.getDateTime(), metadata.getTimeZone()!)
  } as StreamData)

export default timestampResolver
